import React from "react";

const Java_indexOf = () => {
  return (
    <div>
      <h1>Java indexOf()</h1>
      <p>This page provides explanations, examples, and common use-cases for Java indexOf() in Java.</p>
    </div>
  );
};

export default Java_indexOf;
